import React, { useState, useEffect, useCallback, useMemo, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import EnhancedTable from "@/components/common/EnhancedTable"
import Box from "@material-ui/core/Box"
import { fetchNoManagerUserList } from "@/redux/actions/userListAction"
import { useDispatch, useSelector } from "react-redux"
import Loading from "@/components/common/Loading"
import { assignManagerRoleToUser } from "@/apis"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
}))

const assignManagerNotificationInit = {
    status: null,
    statusMsg: "",
}

const AssignManagerTable = memo((props) => {
    const { userCompanyId } = props
    const classes = useStyles()
    const [columns] = useState(() => [
        { id: "firstName", label: "First name", minWidth: 130 },
        { id: "lastName", label: "Last name", minWidth: 130 },
        { id: "email", label: "Email", minWidth: 130 },
    ])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchNoManagerUserList(userCompanyId))
    }, [userCompanyId])

    const { loading, userList: listInit, error } = useSelector((state) => state.userListReducer)
    const { user: userDetail } = useSelector((state) => state.userReducer)

    const list = useMemo(() => listInit.map((item) => ({ ...item, id: item.userId })), [listInit])
    const [filterList, setFilterList] = useState()

    const [assignManagerNotification, setAssignManagerNotification] = useState(assignManagerNotificationInit)
    const assignManagerNotificationSnackbarValue = useHandleRequestSnackbar(assignManagerNotification)

    const assignManager = useCallback(
        async (e, selected) => {
            const createUserName = userDetail.lastName ? `${userDetail.firstName} ${userDetail.lastName}` : userDetail.firstName
            e.stopPropagation()
            // assign manager
            if (selected.length > 0) {
                const promise = selected.map((selectedUserId) => {
                    return assignManagerRoleToUser(selectedUserId, createUserName)
                })
                try {
                    await Promise.all(promise)
                    dispatch(fetchNoManagerUserList(userCompanyId))
                    setAssignManagerNotification({
                        status: true,
                        statusMsg: "New project manager successfully assigned",
                    })
                } catch (assignError) {
                    setAssignManagerNotification({
                        status: false,
                        errorMsg: assignError.data?.message || "Failed to add",
                    })
                }
            }
        },
        [list]
    )

    const action = (selected) => {
        return (
            <Button onClick={(e) => assignManager(e, selected)} variant="contained" color="primary">
                Assign Manager
            </Button>
        )
    }

    const searchFunc = (e) => {
        const filterListValue = list.filter((item) => item.email.includes(e.target.value))
        setFilterList(filterListValue)
    }

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {error ? (
                        <div>Error</div>
                    ) : (
                        <Box mt={1} className={classes.participantNoRoleListTableWrapper}>
                            <EnhancedTable
                                columns={columns}
                                rows={filterList || list}
                                action={action}
                                tableTitle="Assign Project Manager From Projects"
                                searchOn
                                searchFunc={searchFunc}
                                searchPlaceHolder="Search Email..."
                            />
                        </Box>
                    )}
                    {assignManagerNotification.status !== null && (
                        <RequestSnackbar
                            status={assignManagerNotification.status}
                            message={assignManagerNotification.statusMsg}
                            snackbarOpen={assignManagerNotificationSnackbarValue.snackbarOpen}
                            handleSnackbarOpenStatus={assignManagerNotificationSnackbarValue.handleSnackbarOpenStatus}
                        />
                    )}
                </>
            )}
        </>
    )
})

export default AssignManagerTable
